import React, { useState } from "react";
import { Modal } from "../../../components/ui/Modal";
import { Input } from "../../../components/ui/Input";
import { Button } from "../../../components/ui/Button";
import type { CustomerInput } from "../customers.types";

interface CustomerManualImportModalProps {
  onClose: () => void;
  onSubmit: (input: CustomerInput) => Promise<void>;
  open: boolean;
}

const INITIAL_FORM: CustomerInput = {
  email: "",
  name: "",
  phone: "",
  city: "",
  postalCode: "",
  country: "",
  address: "",
};

export function CustomerManualImportModal({ onClose, onSubmit, open }: CustomerManualImportModalProps) {
  const [form, setForm] = useState<CustomerInput>(INITIAL_FORM);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const setField = (field: keyof CustomerInput, value: string) => {
    setForm((current) => ({ ...current, [field]: value }));
  };

  const handleSubmit = async (event: React.FormEvent) => {
    event.preventDefault();
    setSaving(true);
    setError(null);
    try {
      await onSubmit({
        ...form,
        phone: form.phone?.trim() ? form.phone.trim() : undefined,
      });
    } catch (submissionError: any) {
      setError(submissionError?.message || "Impossible d'ajouter le client.");
      setSaving(false);
      return;
    }
    setSaving(false);
  };

  return (
    <Modal onClose={onClose} title="Import manuel · client" wide open={open}>
      <form onSubmit={handleSubmit} className="space-y-4">
        <div className="grid gap-3 sm:grid-cols-2">
          <Input label="Nom" value={form.name} onChange={(event) => setField("name", event.target.value)} required />
          <Input label="Email" type="email" value={form.email} onChange={(event) => setField("email", event.target.value)} required />
          <Input label="Téléphone" value={form.phone || ""} onChange={(event) => setField("phone", event.target.value)} placeholder="Optionnel" />
          <Input label="Ville" value={form.city} onChange={(event) => setField("city", event.target.value)} required />
          <Input label="Code postal" value={form.postalCode} onChange={(event) => setField("postalCode", event.target.value)} required />
          <Input label="Pays" value={form.country} onChange={(event) => setField("country", event.target.value)} required />
        </div>

        <Input label="Adresse" value={form.address} onChange={(event) => setField("address", event.target.value)} required />

        {error && <div className="text-sm text-error">{error}</div>}

        <div className="flex flex-col-reverse gap-2 sm:flex-row sm:justify-end">
          <Button type="button" variant="ghost" onClick={onClose} disabled={saving}>
            Annuler
          </Button>
          <Button type="submit" variant="accent" disabled={saving}>
            {saving ? "Ajout en cours..." : "Ajouter le client"}
          </Button>
        </div>
      </form>
    </Modal>
  );
}